/** A dedicated conversation window may change hosts; the main Guide must stay put. */
export function standaloneChatWindow(href: string, topLevel: boolean): boolean {
  return topLevel && new URL(href).searchParams.get('panel') === 'berater-chat';
}

/** Preserve the selected old session even across the existing FernGuide login hop. */
export function remoteChatUrl(address: string, currentHref: string, session?: string): string {
  const url = new URL(address, currentHref);
  if (session) {
    if (url.pathname === '/api/fern-guide/anmelden' && url.searchParams.has('ziel')) {
      const target = new URL(url.searchParams.get('ziel')!, url.origin);
      if (target.origin === url.origin) {
        target.searchParams.set('sitzung', session);
        url.searchParams.set('ziel', `${target.pathname}${target.search}${target.hash}`);
      }
    } else url.searchParams.set('sitzung', session);
  }
  return url.toString();
}

export function navigateToChat(address: string): void {
  window.location.replace(address);
}
